<template>
  <main>
    <!-- Hero -->
    <section>
      <vf-carousel
        class="overflow-hidden"
        class-controls="mx-6 md:hidden"
        style-controls="transform: scale(1.5); border-radius: 50%"
      >
        <template v-for="(activity, index) in hero.activities" :key="index">
          <div
            class="group relative w-full overflow-hidden md:shrink md:basis-1/3 md:focus-within:basis-2/3 md:hover:basis-2/3"
            style="transition: flex-basis 300ms linear"
          >
            <div :aria-label="activity.title" class="h-screen">
              <base-picture v-bind="activity.image[activeGender] || activity.image" class="full" fit="cover" />
            </div>
            <div
              class="pointer-within absolute-0 f-col items-center justify-end pb-12 md:op-0 md:duration md:group-focus-within:op-100 md:group-hover:op-100"
              style="
                background: linear-gradient(
                  to top,
                  #000,
                  rgba(0, 0, 0, 0.8) 10%,
                  rgba(0, 0, 0, 0.6) 20%,
                  rgba(0, 0, 0, 0.3) 60%,
                  transparent 100%
                )
              "
            >
              <base-picture
                v-style:w=" { sm: '18vw', md: '6vw' }"
                v-bind="hero.logo"
                class="pointer-events-none"
              />
              <h2 class="pointer-events-none my-5 text-3xl c-white fw-bold">
                {{ activity.title }}
              </h2>
              <div v-style:cols="{ md: '1fr 1fr' }" class="gap-2 md:grid <md:w-4/5 <md:f-col <md:center">
                <vf-button
                  v-for="({ to }, key) in activity.buttons[activeGender]"
                  :key
                  class="flex-1 <md:w-2/3"
                  :to
                  variant="primary-inverse"
                >
                  {{ key === 0 ? $t.shopNow : $t.exploreMore }}
                </vf-button>
              </div>
            </div>
          </div>
        </template>
      </vf-carousel>
    </section>
  </main>
</template>

<script lang="ts" setup>
definePageMeta({ header: { transparent: true } })

const route = useRoute()
const router = useRouter()
const { $t } = useNuxtApp()
const { data, error } = await useApi().internal.getStaticPage('summit-series-emea')

if (!data.value) throw createError({ ...error.value!, fatal: true })

const { hero } = data.value
const activeGender = ref(String(route.query.gender || 'men'))

onMounted(() => {
  if (!route.query.gender)
    router.replace({ query: { ...route.query, gender: activeGender.value } })
})
</script>
